export default "__VITE_ASSET__llTVglqz__"